/** Bits shared by the Team Performance synopsis and the rep detail page. */
import { Badge } from '../../components/common/index.jsx';

export const STATUS = {
  on_track: { tone: 'emerald', label: 'On track' },
  at_risk: { tone: 'amber', label: 'At risk' },
  behind: { tone: 'rose', label: 'Behind' },
  no_target: { tone: 'neutral', label: 'No target' },
};

export const StatusBadge = ({ status }) => <Badge tone={STATUS[status]?.tone}>{STATUS[status]?.label ?? status}</Badge>;

/** period/from/to as URL search params, defaulting to the current month. */
export function readPeriod(sp) {
  return { period: sp.get('period') ?? 'month', from: sp.get('from') ?? '', to: sp.get('to') ?? '' };
}

/** Percentage-point / percent change against the previous period; null when there is nothing to compare. */
export const changePct = (now, before) => (before ? Math.round(((now - before) / before) * 100) : null);
export const changePts = (now, before) => (before == null ? null : Math.round((now - before) * 10) / 10);
